import SavingsStatusCard from './SavingsStatusCard'

export default SavingsStatusCard
